import { TPreferencesLayer } from '@/shared/features/filter-preferences/context/filter-preferences-config-context.types';
import { TFilterDefaults } from '@/shared/types/ui-preferences.types';

// Read fresh, not from cache: a stale or empty snapshot would drop other
// preferences when the backend replaces the blob wholesale, and would hit the
// double-toasting version conflict.
export const commitPreferences = async <TBlob>(
  layer: TPreferencesLayer<TBlob>,
  merge: (blob: TBlob) => TBlob,
): Promise<void> => {
  const fresh = await layer.readFresh();
  await layer.submit({ blob: merge(fresh.blob), version: fresh.version });
};

// '' is a valid stored value (an explicitly cleared default), not a deletion.
export const setFilterDefaultInDefaults = (
  defaults: TFilterDefaults | undefined,
  scopeKey: string,
  param: string,
  value: string,
): TFilterDefaults => ({
  ...defaults,
  [scopeKey]: {
    ...defaults?.[scopeKey],
    filters: {
      ...defaults?.[scopeKey]?.filters,
      [param]: value,
    },
  },
});

// Deletes the key entirely — distinct from storing '' — so resolution falls through.
export const removeFilterDefaultFromDefaults = (
  defaults: TFilterDefaults | undefined,
  scopeKey: string,
  param: string,
): TFilterDefaults => {
  const scope = defaults?.[scopeKey];
  if (!scope?.filters || !(param in scope.filters)) return defaults ?? {};

  const { [param]: _removed, ...filters } = scope.filters;

  return {
    ...defaults,
    [scopeKey]: { ...scope, filters },
  };
};
